<template>
  <div>
     <el-dialog :visible.sync="telShow" width="400px" @close="handleClose" :close-on-click-modal="false">
      <div class="tel-change-main">
      <div class="change-bind-tel">
        <div class="change-bind-areanum">
          <span class="area-num-icon">+</span>
          <el-select v-model="areaNum" placeholder="请选择">
            <el-option v-for="item in areaCodeList" :key="item.numcode" :label="item.phonecode" :value="item.phonecode">
              <span style="float: left">{{ item.nameZh }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.phonecode }}</span>
            </el-option>
          </el-select>
        </div>
        <input type="text" name="" id="" placeholder="请输入新手机号" v-model="telNum" autocomplete="off"/>
      </div>
      <div class="check-code">
        <input placeholder="请输入验证码" v-model="code" autocomplete="off" />
        <button class="get-check-code" @click="sendMsg(areaNum, telNum)" v-if="phone_text === '获取验证码'">
          {{ phone_text }}
        </button>
        <button class="get-check-code unactive" v-else>
          {{ phone_text }}
        </button>
      </div>
      <div class="comfirm-btn" @click="this.updatePhone">
        <button>确定</button>
      </div>
    </div>
     </el-dialog>
  </div>
</template>
<script>
import sendMessage from '../../mixins/sendMessage'

export default {
  data() {
    return {
      code: '',
      areaNum: '86',
      telNum: '',
      phone_text: '获取验证码',
      isShow: true
    }
  },
  mixins: [sendMessage],
  props: ['areaCodeList','telShow'],
  methods: {
    handleClose() {
      this.$emit('onCloseWindow')
    },
    // 修改绑定手机号
    updatePhone() {
      if (!this.telNum || !this.code) {
        this.$message({
          message: '手机号、验证码不能为空',
          type: 'error'
        })
      }
      const data = {
        area: this.areaNum,
        phone: this.telNum,
        code: this.code
      }
      this.$axios.post('/user/index/updatePhone', data).then(res => {
        if (res.data.code === 200) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.handleClose()
        } else {
          this.$message({
            message: res.data.message,
            type: 'error'
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.tel-change {
  width: 420px;
  height: 257px;
  background-color: rgb(245, 246, 247);
  position: fixed;
  top: 20%;
  left: 37%;
  border-radius: 12px;
}
.close-btn {
  position: absolute;
  top: 8px;
  right: 16px;
  color: #888888;
  font-size: 20px;
  cursor: pointer;
}
.get-check-code {
  position: absolute;
  right: 0;
  height: 100%;
  padding: 0 20px;
  background: transparent;
  border: none;
  border-left: #e8eaec 1px solid;
  color: #1872ed;
  cursor: pointer;
}
.unactive {
  color: #737373;
}
.tel-change-main {
  display: flex;
  align-items: center;
  flex-direction: column;
  .change-bind-tel {
    position: relative;
    width: 300px;
    height: 44px;
    background: #ffffff;
    border: 1px solid #dfe1e5;
    .change-bind-areanum {
      position: absolute;
      left: 0;
      width: 70px;
      text-align: center;
      color: #808695;
      .area-num-icon {
        z-index: 99;
        position: absolute;
        left: 6px;
        top: 9px;
        font-size: 14px;
      }
    }
    .change-bind-areanum::after {
      width: 1px;
      height: 20px;
      content: '';
      display: block;
      background: #e8eaec;
      position: absolute;
      right: 5px;
      top: 10px;
    }
    input {
      box-sizing: border-box;
      padding-left: 70px;
    }
  }
  .check-code {
    margin-bottom: 20px;
    position: relative;
    width: 300px;
    height: 44px;
    background: #ffffff;
    border: 1px solid #dfe1e5;
    input {
      box-sizing: border-box;
      padding-left: 20px;
    }
  }
  input {
    width: 100%;
    height: 100%;
    line-height: 44px;
    border: none;
    outline: none;
    font-size: 14px;
  }
  .comfirm-btn {
    width: 150px;
    height: 40px;
    font-size: 16px;
    border-radius: 30px;
    overflow: hidden;
    button {
      width: 100%;
      background: linear-gradient(132deg,#73aaff 7%, #0053ff 95%);
      height: 100%;
      border: none;
      color: rgb(255, 255, 255);
      cursor: pointer;
    }
  }
}
.change-bind-tel {
  margin-bottom: 20px;
}
.change-bind-areanum {
  ::v-deep .el-select {
    position: absolute;
    right: 0px;
    top: 0;
  }
}
.change-bind-areanum {
  ::v-deep .el-input__inner {
    border: none;
  }
}
.change-bind-areanum {
  ::v-deep .el-input__inner {
    position: relative;
    left: 5px;
    background: transparent;
  }
}
.change-bind-areanum {
  ::v-deep .el-select__caret {
    color: #1872ed !important;
  }
}
::v-deep .el-dialog{
  top:10%;
  border-radius: 12px;
}
</style>
